<template>
    <div>
        <SelectTreePopup :show="unitPanel" :defaultSelected="search.unitId?{id:search.unitId,name:search.unitName}:{}"
                         :treeData="unitTree"
                         :defaultTitle="unitName" @ok="onUnitOk" @cancel="onUnitCancel"/>
        <layout>
            <Search slot="header-bar" placeholder="请输入关键字搜索" v-model="search.input" @search="onRefresh">
                <div slot="left-icon">
                    <button slot="left-icon" @click="statePanel=true"
                            style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">
                        {{taskState}}
                    </button>
                    <!--<button slot="left-icon" @click="unitPanel=true"-->
                    <!--style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">-->
                    <!--{{unitName}}-->
                    <!--</button>-->
                </div>
            </Search>
            <PullRefresh v-model="isReFresh" @refresh="onRefresh">
                <List
                        style="margin-top:-5px;padding: 5px 12px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        loading-text="拼命加载中..."
                        @load="onLoad"
                        :offset="50"
                        :immediate-check="true"
                >
                    <TaskSafeItem v-for="item in taskSafes" :key="item.id" :taskSafe="item"/>
                </List>
            </PullRefresh>
        </layout>
        <SelectDict :showAll="true" dictKey="SAFETY_TASK_STATE" :show="statePanel"
                    @ok="onStateOk" @cancel="statePanel=false"/>
    </div>
</template>

<script>
    import {Button, List, PullRefresh, Search} from "vant"
    import TaskSafeItem from "../components/TaskSafeItem"
    import {formatSearchData} from "@/utils/format";
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import SelectDict from "@/components/SelectPopup/SelectDict";
    import {mapGetters} from 'vuex'

    export default {
        components: {
            TaskSafeItem, Search, PullRefresh, List, Button,
            SelectTreePopup, SelectDict
        },
        props: {},
        data() {
            return {
                show: false,
                taskSafes: [],
                search: {
                    input: null,
                    unitId: null,
                    unitName: null,
                    state: null,
                    stateName: null,
                },
                isReFresh: false,
                loading: false,
                finished: false,
                unitPanel: false,
                statePanel: false,
            }
        },
        computed: {
            ...mapGetters({unitTree: 'global/unitList'}),
            unitName() {
                return this.search.unitName || '选择单位'
            },
            taskState() {
                return this.search.stateName || "全部"
            }
        },
        created() {
            this.$initUnit(this.search)
        },
        mounted() {
        },
        methods: {
            onStateOk(data) {
                this.search.stateName = data.codeName;
                if (data.code == "All") this.search.state = null;
                else this.search.state = data.code;
                this.onRefresh()
                this.statePanel = false;
            },
            onUnitCancel() {
                this.unitPanel = false;
            },
            onUnitOk(data) {
                this.unitPanel = false;
                this.changeUnit(data)
            },
            changeUnit(unit) {
                this.search.unitId = unit.id
                this.search.unitName = unit.name
                this.onRefresh()
            },
            addSafeTask() {
                this.show = true;
            },
            switchPanel(type, data) {
                switch (type) {
                    case "safeTaskPopup":
                        this.show = !this.show;
                        break;
                    default:
                        break;
                }
            },
            onRefresh() {
                this.isReFresh = true;
                this.taskSafes = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                const data = {
                    name: this.search.input,
                    unitId: this.$default.unitOrOrgan.id,
                    state: this.search.state,
                    size: 20,
                    page: this.taskSafes.length / 20 + 1
                }
                formatSearchData(data);
                this.$http.tokiot.safety.task.list(data).then(res => {
                    if (res) {
                        this.taskSafes.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.taskSafes.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 51px;
        width: calc(100% - 16px);
    }
</style>